import { formatApproximateDuration } from '../../util/formatters';

export const makeDurationLabel = (durationSeconds: number | null) => {
  if (durationSeconds === null) {
    return '';
  }
  if (durationSeconds < 60) {
    return `${durationSeconds} secs`;
  }
  const durationMinutes = durationSeconds / 60;
  const { label, number } = formatApproximateDuration(durationMinutes);
  return `${number} ${label}`;
};
